import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

interface ScrollToTopProps {
  behavior?: 'auto' | 'smooth';
  top?: number;
  left?: number;
}

/**
 * ScrollToTop component that automatically scrolls to the top
 * when the route changes in React Router
 * 
 * @param behavior - Scroll behavior ('auto' or 'smooth')
 * @param top - Target scroll position from top (default: 0)
 * @param left - Target scroll position from left (default: 0)
 */
const ScrollToTop = ({ 
  behavior = 'smooth', 
  top = 0, 
  left = 0 
}: ScrollToTopProps = {}) => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Check if smooth scrolling is supported
    const supportsSmoothScrolling = 'scrollBehavior' in document.documentElement.style;
    
    if (supportsSmoothScrolling) {
      // Modern browsers support smooth scrolling
      window.scrollTo({
        top,
        left,
        behavior
      });
    } else {
      // Fallback for older browsers
      window.scrollTo(top, left);
    }
  }, [pathname, behavior, top, left]);

  return null; // This component doesn't render anything
};

export default ScrollToTop;
